'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/react-google-charts/~/react/react.js
// module id = 1090
// module chunks = 0